<div>
  <img src="assets/block-separator.jpg" alt="" />
</div>
